module.exports = require("@pandora/feature-flag-vendors");